module.exports = __webpack_public_path__ + "static/img/process.dfc917c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/aboutUs/developmentHistory/process.png
// module id = Ok6H
// module chunks = 1